<template>
  <div>
      <section id="kalkulator" class="pt-3 mt-3">

        <ul class="nav nav-tabs" id="kkTabs" role="tablist">
  <li class="nav-item" role="presentation">
    <button class="nav-link active" id="k-tab" data-bs-toggle="tab" data-bs-target="#kalkulator-tab" type="button" role="tab" aria-controls="kalkulator-tab" aria-selected="true">{{$t('ic_kk_znam_oferte')}}<br/>{{$t('ic_kk_zamow_karte')}}</button>
  </li>
  <li class="nav-item" role="presentation">
    <button class="nav-link" id="f-tab" data-bs-toggle="tab" data-bs-target="#rozmowa" type="button" role="tab" aria-controls="rozmowa" aria-selected="false">{{$t('ic_kk_chce_poznac_szczegoly')}}<br/><i class="bi bi-telephone"></i> {{$t('ic_kk_zamow_rozmowe')}}</button>
  </li>
</ul>

        <div class="row ">

          <div class="col-12 col-md-6 tab-content">
            <div class="tab-pane fade show active"  id="kalkulator-tab">
            <div class="form d-flex justify-content-center  flex-column align-items-center">
              
              <h3>{{$t('ic_kk_wybierz_swoja_karte')}}</h3>
              <FormWrapper id="kalkulator">
                <div class="form-group d-none" :class="{'has-error':!kalkulator.ilosc && kalkulator.isTouched}">
                  <label class="sr-only" id="ilosc_label">{{$t('ic_kk_wybierz_liczbe_przejazdow_i_oblicz')}}</label>
<!--                   <ic-input id="ilosc" v-model="kalkulator.ilosc" placeholder="wpisz tygodniową liczbę przejazdów"
                    required
                  ></ic-input>
 -->
                  <ic-select
                    id="ilosc"
                    v-model="kalkulator.ilosc"
                    :values="ilosci"
                    :searchable="true"
                    :allowEmpty="false"
                    :placeholder="$t('ic_kk_wybierz_liczbe_przejazdow')"
                    required
                  ></ic-select>


                  <label for="ilosc" :aria-label="$t('ic_kk_blad_pole_wymagane')" class="error" v-if="!kalkulator.ilosc && kalkulator.isTouched">{{$t('ic_kk_pole_wymagane')}}</label>
                </div>
                  <div class="form-group" :class="{'has-error':!kalkulator.waznosc && kalkulator.isTouched}">
                    <label class="sr-only" id="waznosc_label">{{$t('ic_kk_wybierz_okres_waznosci_pole_wymagane')}}</label>
                  <ic-select
                    id="waznosc"
                    v-model="kalkulator.waznosc"
                    :values="waznoscOptions"
                    :searchable="true"
                    :allowEmpty="false"
                    :placeholder="$t('ic_kk_wybierz_okres_waznosci')"
                    required
                  ></ic-select>
                  <label for="waznosc" :aria-label="$t('ic_kk_blad_pole_wymagane')" class="error" v-if="!kalkulator.waznosc && kalkulator.isTouched">{{$t('ic_kk_pole_wymagane')}}</label>
                  </div>
                  <div class="form-group" :class="{'has-error':!kalkulator.klasa && kalkulator.isTouched}">
                    <label class="sr-only" id="klasa_label">{{$t('ic_kk_wybierz_klase_podrozy_pole_wymagane')}}</label>
                  <ic-select
                    id="klasa"
                    v-model="kalkulator.klasa"
                    :values="klasaOptions"
                    :searchable="true"
                    :allowEmpty="false"
                    :placeholder="$t('ic_kk_wybierz_klase_podrozy')"
                    required
                  ></ic-select>
                  <label for="klasa" :aria-label="$t('ic_kk_blad_pole_wymagane')" class="error" v-if="!kalkulator.klasa && kalkulator.isTouched">{{$t('ic_kk_pole_wymagane')}}</label>
                </div>
                <div class="form-group" :class="{'has-error':!kalkulator.type && kalkulator.isTouched}">
                  <label class="sr-only" id="c_type_label">{{$t('ic_kk_wybierz_typ_karty_pole_wymagane')}}</label>
                  <ic-select
                    id="c_type"
                    v-model="kalkulator.type"
                    :values="typeOptions"
                    :searchable="true"
                    :allowEmpty="false"
                    :placeholder="$t('ic_kk_wybierz_typ_karty')"
                    required
                  ></ic-select>
                  <label for="c_type" :aria-label="$t('ic_kk_blad_pole_wymagane')" class="error" v-if="!kalkulator.type && kalkulator.isTouched">{{$t('ic_kk_pole_wymagane')}}</label>
                </div>
                  
              </FormWrapper>
              <div class="d-flex justify-content-center btns">
                  <button class="btn-primary btn me-5 mr-5 d-none" @click="oblicz(false,$event)">{{$t('ic_kk_oblicz_oszczednosci')}}</button> 
                  <button class="btn-success btn" @click="oblicz(true,$event)">{{$t('ic_kk_zamawiam_karte')}}</button>  
              </div>
              </div>
            </div>
            <div class="tab-pane fade"  id="rozmowa">
              <div class="form d-flex justify-content-center  flex-column align-items-center">
                <form method="post">
                                  <div id="kalkulator">
                                  <h3 class="h4">{{$t('ic_kk_zamow_rozmowe_intro')}}</h3>
                                      <div class="form-floating">
                                        <input class="form-control" placeholder="Wpisz numer telefonu" id="floatingTextarea" required name="phone" maxlength="9"/>
                                        <label style="padding: 0.5rem 1.25rem;" for="floatingTextarea">{{$t('ic_kk_wpisz_numer_telefonu')}}</label>
                                      </div>
                                      <div class="form-check mt-3 ms-1">
                                        <input class="form-check-input" type="checkbox" value="1" id="defaultCheck1" required>
                                        <label class="form-check-label text-white" for="defaultCheck1">
                                          {{$t('ic_kk_zamow_rozmowe_zgoda')}}
                                        </label>
                                      </div>
                                  </div>
            
                                  <div class="d-flex w-100 justify-content-center btns">
                                      <button class="btn-primary btn me-5 mr-5" type="submit">{{$t('ic_kk_zamawiam_rozmowe')}}</button> 
                                  </div>
                                </form>

                </div>
              </div>
          
            
          </div>


          <div class="col-12 col-md-5 offset-md-1 mt-5 mt-md-0" v-html="$t('ic_kk_prawa_strona')">
          </div>
        </div>
        <div class="mt-5 pt-5" v-html="$t('ic_kk_legal')">
        </div>
      </section>
      <section id="info" v-show="kalkulator.isCalculated">
      <div class="row">
            <div class="col-12">
            <div class="bg">  
              <h2 class="text-center">{{$t("ic_kk_Karta idealna dla Twojego Biznesu")}}</h2>
              <div class="row">
                <div class="col-md-6">
                    <div class="karta" :class="kalkulator.wybrana.id">
                    <div class="head">
                      <p>
                        {{$t("ic_kk_Karta INTERCITY")}}<br/>
                        <span >{{k_waznosc}}</span> <span >{{k_typ}}</span><br/>
                        <span>{{$t("ic_kk_KLASA")}} {{kalkulator.klasa}}</span> - <span>{{k_discount}}</span>
                        <br/>
                      </p>
                    </div>  
                    </div>

                  
                </div>
                <div class="col-md-6">
                  <div v-if="kalkulator.wybrana.oszczednosc <= 0">

                    <div class="h3">{{$t("ic_kk_Cena")}}:</div>
                    <div class="h2">{{kalkulator.wybrana.cena | formatNumber}} zł</div>

                     <p class="h4" v-if="kalkulator.wybrana.id == 'zlota' && kalkulator.klasa == 1">{{$t("ic_kk_Oszczędzasz już przy 2 przejazdach tygodniowo")}}</p>
                     <p class="h4" v-if="kalkulator.wybrana.id == 'zlota' && kalkulator.klasa == 2">{{$t("ic_kk_Oszczędzasz już przy 3 przejazdach tygodniowo")}}</p>
                     <p class="h4" v-if="kalkulator.wybrana.id == 'srebrna' || kalkulator.wybrana.id == 'niebieska' ">{{$t("ic_kk_Oszczędzasz już przy 3 przejazdach tygodniowo")}}</p>
                     <p class="h4" v-if="kalkulator.wybrana.id == 'zielona'">{{$t("ic_kk_Oszczędzasz już przy 4 przejazdach tygodniowo")}}</p>
                     <div class="pt-4 mt-4">&nbsp;</div>
                  </div>
                  <div v-if="kalkulator.wybrana.oszczednosc > 0">
                    <div class="h3">{{$t("ic_kk_Darmowe przejazdy po")}}:</div>
                    <div class="h2">{{kalkulator.wybrana.tydzien}}. {{$t("ic_kk_tygodniu")}}</div>
                    <div class="h3">{{$t("ic_kk_Cena karty")}}:<br/> {{kalkulator.wybrana.cena | formatNumber}} zł</div>
                    <div class="h3" >{{$t("ic_kk_Oszczędzasz")}}: <br/> <div class="h3">{{kalkulator.wybrana.oszczednosc | formatNumber}} zł<sup>2</sup></div></div>

                  </div>

                  


                  <a href="#" class="btn btn-primary" @click="zamow(kalkulator.wybrana, $event)">{{$t("ic_kk_zamow")}}</a>
                </div>
              </div>
            </div> 
            <div v-if="kalkulator.ilosc > 2">
              <h3 class="text-center">{{$t("ic_kk_inne warianty")}}</h3>
              <div class="d-flex  justify-content-between flex-column flex-md-row" v-if="kalkulator.isCalculated">
                <div class="wariant d-flex flex-column" v-for="karta in kalkulator.pozostale" :key="karta.id">
                   <div class="karta" :class="karta.id">
                    <div class="head">
                      <p>
                        {{$t("ic_kk_Karta INTERCITY")}}<br/>
                        <span >{{karta.name}}</span> <span >{{k_typ}}</span><br/>
                        <span>{{$t("ic_kk_KLASA")}} {{kalkulator.klasa}}</span> - <span>{{k_discount}}</span>
       
                        <br/>
                      </p>
                    </div>  
                    </div>

                  <span class="light-blue">{{$t("ic_kk_Darmowe przejazdy po")}}:</span>
                  <div class="okres">{{karta.tydzien}}. tygodniu</div>
                  <span class="cena">{{$t("ic_kk_Cena karty")}}: <br/>{{karta.cena | formatNumber }} zł</span>
                  <span class="cena" v-if="karta.oszczednosc > 0">{{$t("ic_kk_Oszczędzasz")}}: <br/><span>{{karta.oszczednosc | formatNumber }} zł</span></span>
                  <span class="cena" v-if="karta.oszczednosc < 0">&nbsp;<br/><span>&nbsp;</span></span>
                  <a href="#" class="btn btn-primary" @click="zamow(karta, $event)">{{$t("ic_kk_zamow")}}</a>
                </div>
              </div>
            </div>
                         




            </div>
          </div>    
          <small class="mt-5 d-block"><sup>2</sup> {{$t("ic_kk_Oszczędność przy założeniu zakupu biletu w cenie bazowej, na przejazd pociągiem kategorii EIP (Pendolino), na przykładowej trasie Warszawa - Kraków lub Warszawa – Gdańsk.")}}</small>
      </section>

   
  </div>

</template>

<script>
import Vue from "vue";

import IcFormRowHorizontal from "@/components/ic-common/form/helpers/FormRowHorizontal.vue";
import IcInput from "@/components/ic-common/form/controls/Input";

import IcSelect from "@/components/ic-common/form/controls/Select";
import IcFormContactEmail from "@/components/ic/form/contact/Base/Email";

import IcTextarea from "@/components/ic-common/form/controls/Textarea";
import VueScrollTo from 'vue-scrollto'

export default {
  name: "KoloroweKartyKalkulator",
  props:{
    calculated:{
      type: Function
    },
    zamow:{
      type: Function
    },
    karty: {
      type: Array
    }
  },
  methods: {
    oblicz(zamow = false, e){

      if(zamow && !this.kalkulator.ilosc) this.kalkulator.ilosc = 99; else if(this.kalkulator.ilosc == 99 && !zamow) this.kalkulator.ilosc = 0;

      this.kalkulator.isTouched = true;
      this.kalkulator.isCalculated = false;
      if(this.kalkulator.ilosc && this.kalkulator.waznosc && this.kalkulator.klasa && this.kalkulator.type){
        this.kalkulator.pozostale = [];

        var opcje = [];
        var that = this;

        for(var i =0; i< that.karty.length; i++){

          var kk_cena = that.karty[i].typ.filter(function(s){return s.id == that.kalkulator.type})[0].klasa[that.kalkulator.klasa];
          var kk_dni = that.karty[i].dni;
          var kk_tygodni = that.karty[i].tygodni;
          var kk_cena_szt = this.kalkulator.klasa == 1?270:177;

          var kk_cena_standard = 2 * kk_cena_szt * kk_dni;
          var kk_oszczednosc = kk_cena_standard - kk_cena;

          var kk_wydatki = kk_cena_szt * kk_tygodni * this.kalkulator.ilosc;
          var kk_oszczednosc_real = kk_wydatki - kk_cena;

          
          var kk_ilosc = Math.round(kk_cena/kk_cena_szt);
          var kk_miesiac = kk_cena / (kk_cena_szt * 4.3333333336 * this.kalkulator.ilosc);
          var kk_tydzien = Math.round(kk_miesiac * 4.3333333336);
          kk_miesiac = Math.round(kk_miesiac * 10) / 10;
          if(kk_tydzien == 0) kk_tydzien = 1;
          opcje.push({id:this.karty[i].id,name:this.karty[i].name, tydzien:kk_tydzien, cena: kk_cena, okres: this.karty[i].okres, oszczednosc: kk_oszczednosc_real, wydatki: kk_wydatki});
          ////console.log(this.karty[i].id,kk_ilosc, kk_tydzien,kk_miesiac);

        }

        
        this.kalkulator.wybrana = opcje.filter(function(s){return s.id == that.kalkulator.waznosc})[0];


          var reszta = opcje.filter(function(s){return s.id != that.kalkulator.waznosc}).sort(function(a,b){
              if (a.tydzien === b.tydzien) {
                      return 0;
                  }
                  else {
                      return (a.tydzien < b.tydzien) ? -1 : 1;
                  }
          });

          this.kalkulator.pozostale = reszta;   
          this.kalkulator.isCalculated = true;      
          
          this.$emit("calculated",this.kalkulator);
          if(zamow){
            this.zamow(this.kalkulator.wybrana, e)
          } else 
            setTimeout(function(){VueScrollTo.scrollTo(document.getElementById('info'));},300);
            

      } else {
        setTimeout(function(){

        let els = document.querySelector('.has-error input');
        if(els)
          els.focus();
        VueScrollTo.scrollTo(els,200);


        }, 100);
      }

    },

  },

  data() {
    return {
      

      waznoscOptions: [
            {id: "zlota",name:this.$t("ic_kk_ROCZNA"), value: "zlota", okres: "rok"},
            {id: "srebrna",name:this.$t("ic_kk_POLROCZNA"), value: "srebrna", okres: "pół roku"},
            {id: "niebieska",name:this.$t("ic_kk_KWARTALNA"), value: "niebieska", okres: "kwartał"},
            {id: "zielona",name:this.$t("ic_kk_MIESIECZNA"), value: "zielona", okres: "miesiąc"},
      ],
      typeOptions: [
          {id: "bezimienna", value:  "bezimienna",name:this.$t("ic_kk_NA_OKAZICIELA")},
          {id: "imienna",    value:  "imienna",   name:this.$t("ic_kk_IMIENNA")}
      ],
      discountOptions: [
        {id: "N", value: "N", name:this.$t("ic_kk_OPLATA_NORMALNA")},
        {id: "U", value: "U", name:this.$t("ic_kk_OPLATA_ULGOWA_50%")}
        ],
      klasaOptions: [
          {id: 1,value: 1, name:this.$t("ic_kk_KLASA_I")},
          {id: 2,value: 2, name:this.$t("ic_kk_KLASA_II")}
        ],
      kalkulator: {
        ilosc:"",
        waznosc: "",
        klasa: "",
        type: "",
        isCalculated:false,
        isTouched:false,
        wybrana: "",
        discount: "N",
        pozostale: []
      },

    };
  },
  computed:{
    ilosci: function(){
      var il = [];
      for(var i=1; i<15;i++){
          il.push({id: i, value:  i,name:i});
      }
      return il;
    },
    k_waznosc: function(){
      var w = this.kalkulator.waznosc;
      var o =  this.waznoscOptions.filter(function(e){
          return e.id == w;
      });
      return o.length?o[0].name:"";
    },
    k_typ: function(){
      var w = this.kalkulator.type;
      var o =  this.typeOptions.filter(function(e){
          return e.id == w;
      });
      return o.length?o[0].name:"";
    },
    k_discount: function(){
      var w = this.kalkulator.discount;
      var o =  this.discountOptions.filter(function(e){
          return e.id == w;
      });
      return o.length?o[0].name:"";
    },

  },
  components: {
    IcFormRowHorizontal,
    IcSelect,
    IcInput,
    
  },
filters: {
  formatNumber: function (value) {
    if (!value) return ''
     
    var decimals = 0, dec_point = "," , thousands_sep = " ", number = value;

    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
   
//    return new Intl.NumberFormat().format(value);
  }
}

};
</script>


<style lang="scss">
.ic-forms {
  h3 {
    margin: 30px 0;
  }
  .has-error {
    label, p {
      color: #ed1c24;
      font-size:14px;
    }
  }
}

#kolorowe-karty,#kolorowe-karty-page {

.form-row {
    padding-top: 20px;
    padding-bottom: 10px;
}

.radio.radio-custom {
    padding: 10px 0px 10px 25px;
}
  
  #kalkulator{
      width:100%;

      .has-error label, .has-error p {
        color: #ed1c24;
        font-size: 14px;
      } 
    .form {
      position: relative;
      background: #018cc1;
      border-radius: 10px;
      border-top-left-radius: 0px;
      padding:27px;
      min-height: 485px;
      .btns {
        position: absolute;
        bottom: 0;
      }
      h3 {
        color:#fff;
        font-size:33px;
        font-weight: vold;
        text-align: center;
      }      

      input {
        
      }
      .form-control, .multiselect {
        height: 44px;
        margin:20px 0 0;
        
      }
      .multiselect__tags {
        min-height: 44px;
        padding: 8px 40px 8px 12px;
      }
      .multiselect__select {
        height:42px;
      }
      .btn {
        transform: translate(0, 31px);
      }    
    }
    .panel{
      margin:0 auto;
      .panel-head {
        h3 {
           background:transparent url(/images/belka.png) no-repeat top left;
          height: 62px;
          color: #fff;
          font-size: 15px;
          font-weight:bold !important;
          padding-left: 112px;
          margin-left: 0;
          margin-bottom: -28px;
          line-height: 23px;
        }
        .ico-liczba {
              background:transparent url(/images/belka_1.png) no-repeat top left;
        }
        .ico-okres{
            background:transparent url(/images/belka_2.png) no-repeat top left;
        }
        .ico-klasa {
            background:transparent url(/images/belka_3.png) no-repeat top left;
        }
        .ico-osob {
            background:transparent url(/images/belka_4.png) no-repeat top left;
        }
      }
      p{
padding-left: 75px;
font-size: 18px;
margin-right: 68px;
min-height: 50px;
      }
    }
  }
  #info {

    margin-top: 80px;
    .bg {
      background: #018cc1;
      border-radius: 10px;
      padding:20px 20px 60px;
    }
    h2{
      color:#fff;
      font-size:40px;
    }
    .h3, .h2, .h4 {
      font-weight: vold;
      color:#fff;
    }
    .h3{
      font-size: 25.67px;
      margin-top:0;
      margin-bottom:0;
      .h3{
        font-size:140%;
        margin:20px 0;    
      }
      sup {
        font-weight:light;
        font-size:40%;
        top:-2rem;
      }
    }
    .h2{
        font-size: 52.33px;
        margin-bottom: 16px;
        margin-top: 16px;
    }
    h3{
      font-size: 33.33px;
      color:#002d59;
      line-height: 60px;
      font-weight: vold;
    }
  }


  #karta {
    .radio-border {
font-size: 20px;
border: 2px solid #002d59;
border-radius: 25px;
margin-top: 38px;
padding-left: 20px;
    }
    .radio-border.selected {
      border-color: #f58220;
    }
    .karta{
      font-weight:bold !important;
      color:#FFF;
      .head {
        font-size: 25px;
        span {
          font-size:17px;
        }
      }
      .waznosc {
        font-size:14px;
      }
    }
  }


}
.radio-group {
 padding-top:5px;
 margin-bottom:13px
}
.radio-custom {
 position:relative;
 padding-left:25px
}
.radio-custom label {
 padding:0
}
.radio-custom input[type=radio] {
 position:absolute;
 width:1px;
 height:1px;
 margin:-1px;
 padding:0;
 overflow:hidden;
 clip:rect(0,0,0,0);
 border:0
}
.radio-custom-btn {
 width:18px;
 height:18px;
 background:#ebebeb;
 border-radius:50%;
 position:absolute;
 top:1px;
 left:0
}
.radio-custom-btn:before {
 content:'';
 width:10px;
 height:10px;
 background:#f58220;
 border-radius:50%;
 opacity:0;
 filter:alpha(opacity=0);
 position:absolute;
 top:4px;
 left:4px
}
input:checked+.radio-custom-btn:before {
 opacity:1;
 filter:alpha(opacity=100)
}
input:focus+.radio-custom-btn {
 outline:solid 2px #f58220;
 background:#d2d2d2
}

#kkTabs {
  border:0;
  .nav-link:hover, .nav-link:focus {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
}
#kkTabs.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    background-color:#018cc1;
    color:#fff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-color: #018cc1;
  }
#kalkulator .tab-content {
  padding:0 12px;border:none;
}

#kkTabs.nav-tabs .nav-link {
  margin-bottom: -1px;
  background: #018cc114;
  border: 1px solid transparent;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

</style>
